import { defineStore } from "pinia"
import { ref } from "vue"
import api from "../composables/useApi"
interface drmLink {
	name: string
	Link: string
}
interface VideoData {
	dash: drmLink[]
	hls: drmLink[]
	fairplay_license: string
	fairplay_cert: string
	widevine_license: string
}

export const useDrmStore = defineStore("useDrmStore", () => {
	const videoData = ref<VideoData | null>(null)
	const loading = ref(false)
	const error = ref<string | null>(null)

	/**
	 * Fetch DRM-secured video data from Drupal endpoint
	 */
	const fetchVideoData = async (uuid) => {
		loading.value = true
		error.value = null

		try {
			const res = await api.get(`/api/drm/video-data/${uuid}`)
			// console.log("DRM Video Data Response:", res.data)
			videoData.value = await res.data
		} catch (err: any) {
			error.value = err.message
		} finally {
			loading.value = false
		}
	}

	return { videoData, loading, error, fetchVideoData }
})
